import React, { useMemo } from 'react';
import ActionGrid from '@/components/common/ActionGrid';
import permissionService from '@/services/PermissionService';
import { CAGridRow } from '@/types/model/corrective-action';
import {
  buildCorrectiveActionActionGridActionColumns,
  buildCorrectiveActionActionGridBulkActions,
  buildCorrectiveActionActionGridColumns,
  buildCorrectiveActionActionGridData,
} from '@/services/util/adapters/CorrectiveActionActionGridAdapter';

interface CorrectiveActionsGridViewProps {
  rows: CAGridRow[];
  onEdit: (row: CAGridRow) => void;
  onAddNew: () => void;
  onSwitchToAccordion: () => void;
}

const CorrectiveActionsGridView: React.FC<CorrectiveActionsGridViewProps> = ({ rows, onEdit, onAddNew, onSwitchToAccordion }) => {
  const columns = useMemo(() => buildCorrectiveActionActionGridColumns(), []);
  const gridData = useMemo(() => buildCorrectiveActionActionGridData(rows), [rows]);
  const actionColumns = useMemo(
    () => buildCorrectiveActionActionGridActionColumns({ rows, onEdit }),
    [rows, onEdit]
  );
  const bulkActions = useMemo(
    () => buildCorrectiveActionActionGridBulkActions({ canAddNew: permissionService.canAddCA(), onAddNew, onSwitchToAccordion }),
    [onAddNew, onSwitchToAccordion]
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', height: 'calc(100vh - 170px)' }}>
      <ActionGrid
        columns={columns}
        gridData={gridData}
        actionColumns={actionColumns}
        bulkActions={bulkActions}
        defaultColDef={{ resizable: true, sortable: true, filter: true, minWidth: 90 }}
        overlayNoRowsTemplate="No corrective actions found."
      />
    </div>
  );
};

export default CorrectiveActionsGridView;
